import { ButtonProps } from "@mui/material";
import classNames from "classnames";
import { AppIconButton } from "../../../../shared/components/AppIconButton";
import { SearchIcon } from "../../../../shared/icons/SearchIcon";
import styles from "./styles.module.css";

interface Props extends ButtonProps {
  isDisabled?: boolean;
  className?: string;
}

export const SearchButton = ({ isDisabled, className, ...rest }: Props) => {
  const cls = classNames(styles.button, styles["search-button"], className);

  return (
    <AppIconButton disabled={isDisabled} className={cls} {...rest}>
      <SearchIcon />
    </AppIconButton>
  );
};
